import { render, staticRenderFns } from "./TimelineTab.vue?vue&type=template&id=548a52ad&"
import script from "./TimelineTab.vue?vue&type=script&lang=js&"
export * from "./TimelineTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports